import React, {Component} from 'react';
import {Button, IconButton, MenuItem, Typography} from "@material-ui/core";
import {SearchTextFieldStyled} from "./styled";
import {SearchOutlined} from "@material-ui/icons";
import {DatePicker} from "@material-ui/pickers";
import {
    ContentColumnSearhExtract,
    ContentColumnSearhExtractSelect,
    ContentParentSearhExtract,
    ContentSearhExtract
} from "../styled";
import FixSelectComponent from "../../../../Components/FixSelect/FixSelect";
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import {ExtractContext} from "../../../../Contexts/ExtractContext";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import DateUtil from "../../../../Utils/DateUtil";
import AutocompleteComponent
    from "../../../../Components/AutocompleteComponent/AutocompleteComponent";
import FormMask from "../../../../FromMask/FormMask";
import {BlockClientContext} from "../../../../Contexts/BlockClientContext";


class SearchTextFieldComponent extends Component {
    static contextType = BlockClientContext;

    constructor(props) {
        super(props);

        this.state = {
            filter: null,
            selectedDateInitial: DateUtil.getDateRangeToDate(7).initial,
            selectedDateInitialApi: DateUtil.getDateRangeFormat(7).initial,
            selectedDateFinal: DateUtil.getDateRangeToDate(7).final,
            selectedDateFinalApi: DateUtil.getDateRangeFormat(7).final,
            client: null,
            key: null,
            type: null,
            companies: null,
            user_name: null,
        };
    }

    handleChange = (event) => {
        const {name, value} = event.target;

        this.setState({[name]: value});
    }

    handleChangeDate(name, value) {

        const apiState = name + 'Api';

        this.setState({
            [name]: value.toDate(),
            [apiState]: value.format('YYYY-MM-DD'),
        });
    }

    makeTypes = () => {
        const itens = [
            <MenuItem key={null} value={null}>{'Nenhum'}</MenuItem>
        ];

        const object = this.context.parent.state?.dataFilter?.types;

        if (!object) {
            return itens;
        }

        Object.keys(object).map((key) => {
            itens.push(
                <MenuItem key={key} value={key}>{object[key]}</MenuItem>
            );
        });

        return itens;
    }

    makeCompanies = () => {
        const itens = [
            <MenuItem key={null} value={null}>{'Nenhum'}</MenuItem>
        ];

        const object = this.context.parent.state?.dataFilter?.companies;

        if (!object) {
            return itens;
        }

        Object.keys(object).map((key) => {
            itens.push(
                <MenuItem key={key} value={key}>{object[key]}</MenuItem>
            );
        });

        return itens;
    }

    makeCompaniesObject = () => {
        const itens = [];

        const object = this.context.parent.state?.dataFilter?.companies;

        if (!object) {
            return itens;
        }

        Object.keys(object).map((key) => {
            itens.push(
                {
                    id: key,
                    title: object[key],
                }
            );
        });

        return itens;
    }

    makeUsers = () => {
        const itens = [
            <MenuItem key={null} value={null}>{'Nenhum'}</MenuItem>
        ];

        const object = this.context.parent.state?.dataFilter?.users;

        if (!object) {
            return itens;
        }

        Object.keys(object).map((key) => {
            itens.push(
                <MenuItem key={key} value={key}>{object[key]}</MenuItem>
            );
        });

        return itens;
    }

    render() {
        return (
            <ContentParentSearhExtract>
                <ContentSearhExtract>
                    <Typography variant={'h6'}
                                color={'primary'}>
                        Filtros
                    </Typography>
                </ContentSearhExtract>
                <SpacerComponent height={30}/>
                <ContentSearhExtract>
                    <SearchTextFieldStyled id="outlined-basic"
                                           label="Busque por nome ou CPF"
                                           variant="outlined"
                                           name={'filter'}
                                           onChange={this.handleChange}/>
                    <SpacerComponent width={40}/>
                    <Button variant={'contained'}
                            color={'primary'}
                            size={"large"}
                            onClick={() => this.context.parent.doSearch(
                                this.state,
                            )}>
                        Filtrar
                    </Button>
                </ContentSearhExtract>
            </ContentParentSearhExtract>
        );
    }
}

export default SearchTextFieldComponent;